import { useState } from "react";
import { toast } from "sonner";
import { Download, FileSpreadsheet, FileText, Loader2, ChevronDown } from "lucide-react";
import * as api from "../../lib/crmApi";

/** Dropdown-knap: eksportér leads som Excel eller CSV. `body` = filtre eller lead_ids. */
export default function ExportMenu({ body, dark = false, label = "Eksportér", testId = "crm-export" }) {
    const [open, setOpen] = useState(false);
    const [busy, setBusy] = useState(false);

    const run = async (format) => {
        setOpen(false); setBusy(true);
        try {
            const name = await api.exportLeads({ ...body, format });
            toast.success(`Downloadet ${name}`);
        } catch (e) {
            toast.error(e?.response?.status === 401 ? "Log ind igen" : "Eksport fejlede");
        } finally { setBusy(false); }
    };

    const btnCls = dark
        ? "bg-white/10 hover:bg-white/20 text-white"
        : "bg-white border border-slate-300 text-slate-700 hover:bg-slate-50";

    return (
        <div className="relative">
            <button type="button" onClick={() => setOpen((v) => !v)} disabled={busy}
                data-testid={`${testId}-btn`}
                className={`inline-flex items-center gap-1.5 rounded-lg px-3 h-9 text-xs font-semibold disabled:opacity-50 ${btnCls}`}>
                {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Download className="h-3.5 w-3.5" />}
                {label} <ChevronDown className="h-3 w-3 opacity-70" />
            </button>
            {open && (
                <div onMouseLeave={() => setOpen(false)}
                    data-testid={`${testId}-menu`}
                    className={`absolute z-50 right-0 ${dark ? "bottom-11" : "top-11"} bg-white text-slate-900 rounded-lg shadow-xl border border-slate-200 py-1 min-w-[220px]`}>
                    <button type="button" onClick={() => run("xlsx")} data-testid={`${testId}-xlsx`}
                        className="w-full text-left px-3 py-2 hover:bg-sky-50 text-sm flex items-center gap-2">
                        <FileSpreadsheet className="h-4 w-4 text-emerald-600" /> Excel (.xlsx) – inkl. ark med noter
                    </button>
                    <button type="button" onClick={() => run("csv")} data-testid={`${testId}-csv`}
                        className="w-full text-left px-3 py-2 hover:bg-sky-50 text-sm flex items-center gap-2">
                        <FileText className="h-4 w-4 text-slate-500" /> CSV – til Google Sheets
                    </button>
                </div>
            )}
        </div>
    );
}
